import { trackAddressError } from '../tracking';

export const resetFormValidityState = form => {
  form['geo.userInput'].$setValidity('needHouse', true);
  form['geo.userInput'].$setValidity('needStreet', true);
  form['geo.userInput'].$setValidity('needCity', true);
  form['geo.userInput'].$setValidity('needLocation', true);
  form['geo.userInput'].$setValidity('notFound', true);
  form['geo.userInput'].$setValidity('serverError', true);
  form['geo.userInput'].$setValidity('needAddress', true);
};

export const setAddressUserInputValidityErrorWithTracking = ({
  form,
  validator,
  isValid,
  isNewOffer = true,
  trackingLabel = 'unknown',
  isAddressCached = false,
  formId,
}) => {
  if (!isAddressCached) {
    trackAddressError(isNewOffer, trackingLabel, formId);
  }

  form['geo.userInput'].$setValidity(validator, isValid);
};
